module.exports = __webpack_public_path__ + "img/brand.577809f9.png";